(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_step-accordion-row"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.classList.contains('step-row__details')) {
        return;
      }

      const wrap = details.querySelector(':scope > .step-row__content-wrap');
      if (!wrap || !details.open) return;

      // Force the collapsed (0fr) state to actually paint first, then hand control back to the
      // CSS transition on the next frame. Without this, opening jumps straight to full height
      // instead of animating (see the comment on .step-row__content-wrap above).
      wrap.style.transition = 'none';
      wrap.style.gridTemplateRows = '0fr';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          wrap.style.transition = '';
          wrap.style.gridTemplateRows = '';
        });
      });
    },
    true // `toggle` events on <details> don't bubble, so this has to run on the capture phase.
  );
  } catch(e) { console.error(e); }
})();

})();
